'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Content = require('./Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Content2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Content/index.js
// module id = 363
// module chunks = 0